import { ITimeSpan } from "./models/basic/timespan.model";
import * as moment from 'moment/moment';
import { ILicense } from "./models/license/license.model";


export class GlobalFunction
{

    public static emptyGuid(): string
    {
        return "00000000-0000-0000-0000-000000000000";
    }

    public static isEmpty(val): boolean
    {
        return (val === undefined || val == null || val.length <= 0 || val == this.emptyGuid()) ? true : false;
    }


    public static getUserRoles(): string[] 
    {

        let authResponseData = JSON.parse(localStorage.getItem('AppointmentManagementUser'));
        if(!GlobalFunction.isEmpty(authResponseData))
        {
            let userRoles = authResponseData.userRoles;
            return (userRoles);
        }
        else
        {
            return [];
        }
    }

    public static modifyStartDateToNow(dates: ITimeSpan[]): ITimeSpan[]
    {

        let dateNow = new Date();
        let dateNowConvertToMoment = moment(dateNow);
        let nowDate = dateNowConvertToMoment.format("YYYY-MM-DDTHH:mm:ss");

        // check if the dates must be modified.
        let filteredRecords = dates.filter(x => new Date(x.start).getTime() < new Date(nowDate).getTime());
        if (filteredRecords.length === 0)
        {
            return dates;
        }

        // here we have a start date to modify
        dates.forEach(function (e)
        {

            if (new Date(e["start"]).getTime() < new Date(nowDate).getTime())
                e["start"] = nowDate;
        });

        return dates;
    }

}
